@if (filteredMenuItems$ | async; as filteredItems) {
  <div class="desktop-sidebar">
    <div class="left-side-bar default-theme oph-scroll-bar">
      <div class="logo-container">
        <img
          class="fullsked-logo fullsked-logo--full"
          src="assets/img/fullsked-logo.svg"
          [routerLink]="'/current-sked'"
          alt="FullSked Logo"
        />
        <img
          class="fullsked-logo fullsked-logo--mini"
          src="assets/img/fullsked-logo-mini.svg"
          [routerLink]="'/current-sked'"
          alt="FullSked Logo"
        />
      </div>
      <div class="navbar-items__container">
        @for (item of menuNavItems; track item.display; let i = $index) {
          @if (isNavItemVisible(item, filteredItems)) {
            <navbar-item
              [item]="item"
              [selected]="item | isRouteActive: routerUrl"
              (itemClick)="itemClickHandler()"
              (groupClick)="groupClickHandler(item?.itemGroup)"
            />
          }
        }
      </div>

      <div class="navbar-footer-actions">
        <navbar-user>
          <ng-container class="user-options-selector">
            @for (item of userNavItems; track item.display; let i = $index) {
              <navbar-item [item]="item" (itemClick)="userItemClickHandler(item)" />
            }
          </ng-container>
        </navbar-user>
        <div class="version-container">
          <span class="version-number">v{{ version }}</span>
        </div>
      </div>
    </div>

    <div class="routes-container" [class.routes-container--open]="isMenuOpen()">
      <div class="routes-container__overlay" (click)="groupClickHandler()"></div>
      <div class="routes-container__routes" [class.routes-changing]="isRoutesChanging()">
        <button class="routes-container__close-button" type="button" (click)="groupClickHandler()">
          <mat-icon [svgIcon]="'x-brown'" />
        </button>
        @if (currentGroupRoutes$ | async; as routes) {
          <route-item-group
            [featuredRoutes]="featuredRoutes()"
            [menuItems]="routes"
            [routerUrl]="routerUrl"
            (menuItemClick)="groupClickHandler()"
          />
        }
      </div>
    </div>
  </div>
}
